import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { fetchConToken } from '../../api/fetch';
import { useForm } from '../../hooks/useForm';
import { useContextInfo } from '../../context/ContextInfo';
import { Button, Col, Form, InputGroup, Row, Spinner } from 'react-bootstrap';
import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai';
import MapaRender from '../map/MapaRender';

const TabDc = () => {
    const { id } = useParams();
    const idR = atob(id);
    const [validated, setValidated] = useState(false);
    const [type, setType] = useState('password');
    const [loading, setLoading] = useState(true);
    const [show, setShow] = useState(false);
    const [coor, setCoor] = useState([]);
    const { setResp } = useContextInfo();
    const [values, handleInputChange, setFormValue] = useForm({
        nodo: '',
        coordenadas: '',
        ip: '',
        seguridad: '2',
        seguridad2: '1',
        pass: '',
        user: '',
        flow: '0',
        velocidad: 'pcq',
        port_api: '',
    });

    useEffect(() => {
        getInfo();
    }, []);
    const getInfo = async () => {
        const res = await fetchConToken(`networks/mktik/${idR}`, 'GET');
        if (res.ok) {
            const { data } = res;
            setFormValue({
                nodo: data.nodo,
                coordenadas: data.coordenadas,
                ip: data.ip,
                seguridad: data.seguridad,
                seguridad2: data.seguridad2,
                secret_radius: data.secret_radius,
                ip_radius: data.ip_radius,
                pass: data.pass,
                user: data.user,
                flow: data.flow,
                velocidad: data.velocidad,

                port_api: data.port_api,
            });
            setLoading(false);
        }
    };
    useEffect(() => {
        passCoords();
    }, [values.coordenadas]);
    const changeCoor = (coords) => {
        setFormValue({ ...values, coordenadas: coords });
    };
    const passCoords = () => {
        if (values.coordenadas?.length > 0) {
            const arr = values?.coordenadas.split(',');
            if (arr.length > 1) {
                setCoor([{ lat: parseFloat(arr[0]), lng: parseFloat(arr[1]) }]);
            }
        }
    };
    const onSubmit = async (event) => {
        const form = event.currentTarget;
        event.preventDefault();
        if (loading) return;

        if (form.checkValidity() === false) {
            setValidated(true);
        } else {
            setLoading(true);
            if (loading) return;
            const res = await fetchConToken(`networks/mktik/${idR}`, values, 'PUT');
            setResp(res);
            setLoading(false);
        }
    };
    return (
        <div>
            <div className="p-3">
                <Form noValidate validated={validated} onSubmit={onSubmit}>
                    <Row>
                        <Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="validationCustom01">
                                    <Form.Label>Nombre</Form.Label>
                                    <Form.Control
                                        required
                                        type="text"
                                        placeholder="Router"
                                        value={values.nodo}
                                        name="nodo"
                                        onChange={handleInputChange}
                                    />
                                    <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                </Form.Group>{' '}
                            </Col>{' '}
                            <Col>
                                {' '}
                                <Form.Group className="mb-3" controlId="validationCustom08">
                                    <Form.Label>Coordenadas</Form.Label>
                                    <InputGroup>
                                        <InputGroup.Text id="inputGroupPrepend" onClick={() => setShow(!show)}>
                                            <i className="mdi mdi-map-marker-radius" />
                                        </InputGroup.Text>
                                        <Form.Control
                                            type="text"
                                            name="coordenadas"
                                            value={values?.coordenadas}
                                            onChange={handleInputChange}
                                        />
                                    </InputGroup>
                                </Form.Group>{' '}
                            </Col>
                            <Row>
                                {' '}
                                <Col>
                                    <Form.Group className="mb-3" controlId="validationCustom02">
                                        <Form.Label>Ip</Form.Label>
                                        <Form.Control
                                            required
                                            type="text"
                                            placeholder="Ip"
                                            value={values.ip}
                                            name="ip"
                                            onChange={handleInputChange}
                                        />
                                    </Form.Group>
                                    <Form.Control.Feedback>Válido</Form.Control.Feedback>{' '}
                                </Col>
                                <Col>
                                    <Form.Group className="mb-3" controlId="validationCustom02">
                                        <Form.Label>Puerto api</Form.Label>
                                        <Form.Control
                                            required
                                            type="number"
                                            placeholder="8728"
                                            value={values.port_api}
                                            name="port_api"
                                            onChange={handleInputChange}
                                            maxLength={4}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Col>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3" controlId="validationCustom022">
                                            <Form.Label> Seguridad</Form.Label>
                                            <Form.Select
                                                value={values.seguridad}
                                                name="seguridad"
                                                required
                                                onChange={handleInputChange}>
                                                <option value="1">Ninguno / Accounting API</option>
                                                <option value="2">PPP / Accounting API </option>
                                                <option value="3">Hotspot / Accounting API</option>
                                                <option value="4">PPP / Accounting Radius</option>
                                                <option value="5">Hotspot / Accounting Radius</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        {' '}
                                        <Form.Group className="mb-3" controlId="validationCustom022">
                                            <Form.Label> Seguridad alterna</Form.Label>
                                            <Form.Select
                                                value={values.seguridad2}
                                                name="seguridad2"
                                                required
                                                onChange={handleInputChange}>
                                                <option value="1">Ninguno</option>
                                                <option value="2">Amarre de IP y Mac </option>
                                                <option value="3">DHCP Leases</option>
                                                <option value="4">IP Binding</option>
                                                <option value="5">Amarre de IP y Mac + DHCP Leases</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Col>
                        </Col>
                        <Col>
                            <h4>MIKROTIK</h4>
                            <Col>
                                <Form.Group className="mb-3" controlId="validationCustom07">
                                    <Form.Label>Usuario</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="user"
                                        required
                                        value={values.user}
                                        onChange={handleInputChange}
                                    />
                                    <Form.Control.Feedback type="invalid">Ingrese un usuario</Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="validationCustom08">
                                    <Form.Label>Contraseña</Form.Label>
                                    <InputGroup hasValidation>
                                        <InputGroup.Text id="inputGroupPrepend">
                                            {type === 'password' ? (
                                                <AiFillEye onClick={() => setType('text')} />
                                            ) : (
                                                <AiFillEyeInvisible onClick={() => setType('password')} />
                                            )}
                                        </InputGroup.Text>
                                        <Form.Control
                                            type={type}
                                            name="pass"
                                            value={values.pass}
                                            onChange={handleInputChange}
                                            required
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Ingrese una Contraseña
                                        </Form.Control.Feedback>{' '}
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="validationCustom022">
                                    <Form.Label> Registro de tráfico</Form.Label>
                                    <Form.Select value={values.flow} name="flow" required onChange={handleInputChange}>
                                        <option value="0">Accounting (RouterOS V6.x)</option>
                                        <option value="1">Traffic Flow (RoutersOS V6x,v7.x) </option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="validationCustom022">
                                    <Form.Label>Control de Velocidad</Form.Label>
                                    <Form.Select
                                        value={values.velocidad}
                                        name="velocidad"
                                        required
                                        onChange={handleInputChange}>
                                        <option value="queues">Colas Simples (Estáticas)</option>
                                        <option value="pcq">PCQ + Addresslist </option>
                                        <option value="dhcp"> DHCP Lease (Colas simples Dinámicas)</option>
                                        <option value="ninguno">Ninguno </option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Col>
                    </Row>
                    {loading ? (
                        <Button color="primary" disabled>
                            <Spinner className="spinner-border-sm me-1" tag="span" color="white" />
                            Guardando...
                        </Button>
                    ) : (
                        <Button type="submit">Guardar</Button>
                    )}
                </Form>
            </div>
            <MapaRender
                show={show}
                onClose={() => setShow(false)}
                legend="Mikortik"
                marks={coor}
                setCoor={changeCoor}
            />
        </div>
    );
};

export default TabDc;
